module.exports = "<div class=row><div class=col-xs-12><rm-jqx-grid grid-id=example grid-data=data grid-settings=settings></rm-jqx-grid></div></div>";